<div class="row mt-5">
  <div class="col-12">
    <div
      class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mt-3 mb-2">
      <h3 class="fw-bold fs-6 mb-0">X Ads Status</h3>
      <i class="bi bi-upload text-primary me-2"></i>
    </div>
    <div class="text-end">
      <button type="button" (click)="refreshActionStatus()"
              class="btn btn-primary btn-sm fw-bold">
        Refresh
      </button>
      <button type="button" (click)="createActions()" *isGranted="['ROLE_API_PARTNER_WRITE']"
              appConfirm
              class="btn btn-danger btn-sm fw-bold ms-1">Create conversion actions
      </button>
    </div>
    @if (conversionGoals === null) {
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    }
    @if (conversionGoals !== null) {
      <table class="table">
        <thead>
        <tr>
          <th>Conversion Goal Name</th>
          <th>Account Pixel ID</th>
          <th>Event Tag ID</th>
          <th>Event Pixel ID</th>
          <th>Status</th>
        </tr>
        </thead>
        <tbody>
          @for (goal of conversionGoals; track goal) {
            <tr>
              <td>{{ goal.name }}</td>
              <td>{{ goal.accountPixelId }}</td>
              <td>{{ goal.id }}</td>
              <td>{{ goal.pixelId }}</td>
              <td>
                @if (goal.enabled) {
                  <span class="text-success">Enabled</span>
                } @else {
                  <span class="text-danger">⚠️ NOT CONFIGURED</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</div>
